import quotationServices from '../../services/quotation';
import Quotation from '../../model/quotation';

export const state = {
    quotation: {},
}

export const mutations = {
    setQuotation(state, quotation) {
        state.quotation = quotation
    }
}

export const getters = {
    getQuotation(state) {
        return new Quotation(state.quotation);
    }
}

export const actions = {
    getAll({commit}, data = {}){
        return quotationServices.getAll(data)
        .then((response)=>{
            commit('setQuotation', response.data.data)
            return response
        })
    },
    edit({commit}, {id, quotation}){
        return quotationServices.edit(id, quotation)
        .then((response)=>{
            commit('setQuotation', response.data.data)
            return response
        })
    },
}